import React from "react";
import { Platform } from "react-native";
import TextField from "./TextField";
import DateFormat from "./DateFormat";
import { format as formatFn, parse as parseFn } from "date-fns";

const normalizeTime = (time) => {
  let newTime = time.replace(/[^\d]/g, "");

  if (newTime.length <= 2) return newTime;

  newTime = newTime.substring(0, 4);
  return `${newTime.substring(0, newTime.length - 2)}:${newTime.substring(newTime.length - 2)}`;
};

const formatText = (text, inFormat, outFormat) => {
  const time = parseFn(text, inFormat, new Date());

  if (isNaN(time)) {
    // A valid time has not been typed, but we update the state anyway because the input is controlled
    return text;
  } else {
    // Update the selection time value
    return formatFn(time, outFormat);
  }
};

/*
 * This component always receives and return time values in format HH:mm, but display it
 * in format H:mm.
 */
const TimeField = ({ onChangeText, value, parseFormat, ...restProps }) => (
  <TextField
    {...restProps}
    value={formatText(value, "HH:mm", "H:mm")}
    labelIcon="clock"
    // Required for iOS, web and Android use our normalize function
    maxLength={5}
    multiline={false}

    onChangeText={text => {
      onChangeText(formatText(normalizeTime(text), "H:mm", "HH:mm"));
    }}
    keyboardType={Platform.OS !== "web" ? "numeric" : null}
  />
);

TimeField.defaultProps = {
  onChangeText: () => {},
  value: ""
};

export default TimeField;
